import React from 'react';
import PropTypes from 'prop-types';
import { BUTTON_ICONS } from '../../../shared/common/Button/Icon';
import { StCampaignMetaLabel, StCampaignMetaValue, StEditIcon } from './MetaDataStyles';
import { useTranslation } from 'react-i18next';

interface Props {
    campaignStartDate?: string;
    icon?: string;
    showStartDateEditButton: boolean;
    onClick?: () => void;

    onEditButtonClick?: () => void;
}

const StartDate = (props: Props) => {
    const { t } = useTranslation();
    const { campaignStartDate, icon = '', showStartDateEditButton, onEditButtonClick } = props;

    return (
        <div data-testid="start-date">
            <StCampaignMetaLabel>{t('marketing.yourCampaigns.campaignStart')}:</StCampaignMetaLabel>
            <StCampaignMetaValue>
                {campaignStartDate
                    ? t('dateFormat.date', {
                          val: new Date(campaignStartDate)
                      })
                    : null}
                {showStartDateEditButton ? <StEditIcon onClick={onEditButtonClick} icon={icon} /> : null}
            </StCampaignMetaValue>
        </div>
    );
};

StartDate.propTypes = {
    campaignStartDate: PropTypes.string,
    icon: PropTypes.oneOf(BUTTON_ICONS),
    showStartDateEditButton: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    onEditButtonClick: PropTypes.func
};

export default StartDate;
